import request from './request'

export function phonePriceList(params) {
    return request({
        method: 'POST',
        url: '/Passageway/phonePriceList',
        data: params,
    })
}
export function phonePriceXiaoyiList(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/phonePriceList',
        data: params,
    })
}
export function phonePriceHandle(params) {
    return request({
        method: 'POST',
        url: '/Passageway/phonePriceHandle',
        data: params,
    })
}
export function addPhoneModel2(params) {
    return request({
        method: 'POST',
        url: '/Passageway/addPhoneModel2',
        data: params,
    })
}
export function selectRamColour(params) {
    return request({
        method: 'POST',
        url: '/Passageway/selectRamColour',
        data: params,
    })
}

export function addPhoneColour(params) {
    return request({
        method: 'POST',
        url: '/Passageway/addPhoneColour',
        data: params,
    })
}
export function addPhoneRam2(params) {
    return request({
        method: 'POST',
        url: '/Passageway/addPhoneRam2',
        data: params,
    })
}
export function delPhoneRam(params) {
    return request({
        method: 'POST',
        url: '/Passageway/delPhoneRam',
        data: params,
    })
}
export function delPhoneColour(params) {
    return request({
        method: 'POST',
        url: '/Passageway/delPhoneColour',
        data: params,
    })
}
export function imageUp(params) {
    return request({
        method: 'POST',
        url: '/Uploadify/imageUp',
        data: params
    })
}

export function addEditPhonePrice(params) {
    return request({
        method: 'POST',
        url: '/Passageway/addEditPhonePrice',
        data: params
    })
}
export function passagewayList(params) {
    return request({
        method: 'POST',
        url: '/Passageway/passagewayList',
        data: params
    })
}
export function storeList(params) {
    return request({
        method: 'POST',
        url: '/Store/storeList',
        data: params
    })
}

export function selectPass(params) {
    return request({
        method: 'POST',
        url: '/Passageway/selectPass',
        data: params
    })
}

export function selectStore(params) {
    return request({
        method: 'POST',
        url: '/Passageway/selectStore',
        data: params
    })
}
export function orderList(params) {
    return request({
        method: 'POST',
        url: '/Passageway/orderList',
        data: params
    })
}

export function orderRemarks(params) {
    return request({
        method: 'POST',
        url: '/Passageway/orderRemarks',
        data: params
    })
}
export function addEditStore(params) {
    return request({
        method: 'POST',
        url: '/Store/addEditStore',
        data: params
    })
}
export function getRegion(params) {
    return request({
        method: 'POST',
        url: '/index/getRegion',
        data: params
    })
}
export function storeInfo(params) {
    return request({
        method: 'POST',
        url: '/Store/storeInfo',
        data: params
    })
}

export function storeHandle(params) {
    return request({
        method: 'POST',
        url: '/Store/storeHandle',
        data: params
    })
}
export function importStore(params) {
    return request({
        method: 'POST',
        url: '/Store/importStore',
        data: params
    })
}
export function downloadStore(params) {
    return request({
        method: 'POST',
        url: '/Store/downloadStore',
        data: params
    })
}

export function passagewayHandle(params) {
    return request({
        method: 'POST',
        url: '/Passageway/passagewayHandle',
        data: params
    })
}
export function passagewayInfo(params) {
    return request({
        method: 'POST',
        url: '/Passageway/passagewayInfo',
        data: params
    })
}
export function addEditPassageway(params) {
    return request({
        method: 'POST',
        url: '/Passageway/addEditPassageway',
        data: params
    })
}
export function orderHandle(params) {
    return request({
        method: 'POST',
        url: '/Passageway/orderHandle',
        data: params
    })
}
export function orderDel(params) {
    return request({
        method: 'POST',
        url: '/Passageway/orderDel',
        data: params
    })
}
export function orderCostPrice(params) {
    return request({
        method: 'POST',
        url: '/Passageway/orderCostPrice',
        data: params
    })
}

export function orderScrapPrice(params) {
    return request({
        method: 'POST',
        url: '/Passageway/orderScrapPrice',
        data: params
    })
}
export function completeOrder(params) {
    return request({
        method: 'POST',
        url: '/Passageway/completeOrder',
        data: params
    })
}
export function partnerList(params) {
    return request({
        method: 'POST',
        url: '/Partner/partnerList',
        data: params
    })
}
export function selectPartner(params) {
    return request({
        method: 'POST',
        url: 'Passageway/selectPartner',
        data: params
    })
}

export function passagewayPhone(params) {
    return request({
        method: 'POST',
        url: '/Passageway/passagewayPhone',
        data: params
    })
}
export function editPassagewayPhone(params) {
    return request({
        method: 'POST',
        url: '/Passageway/editPassagewayPhone',
        data: params
    })
}
export function selectAgent(params) {
    return request({
        method: 'POST',
        url: '/Passageway/selectAgent',
        data: params
    })
}

export function partnerList2(params) {
    return request({
        method: 'POST',
        url: '/Partner/partnerList',
        data: params
    })
}

export function partnerHandle(params) {
    return request({
        method: 'POST',
        url: '/Partner/partnerHandle',
        data: params
    })
}

export function partnerInfo(params) {
    return request({
        method: 'POST',
        url: '/Partner/partnerInfo',
        data: params
    })
}
export function addEditPartner(params) {
    return request({
        method: 'POST',
        url: '/Partner/addEditPartner',
        data: params
    })
}
export function agentList(params) {
    return request({
        method: 'POST',
        url: '/Partner/agentList',
        data: params
    })
}
export function agentHandle(params) {
    return request({
        method: 'POST',
        url: '/Partner/agentHandle',
        data: params
    })
}
export function agentInfo(params) {
    return request({
        method: 'POST',
        url: '/Partner/agentInfo',
        data: params
    })
}
export function addEditAgent(params) {
    return request({
        method: 'POST',
        url: '/Partner/addEditAgent',
        data: params
    })
}
//报价单下载
export function uploadXyAssess(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/uploadXyAssess',
        data: params,
        responseType: 'blob'
    })
}
export function orderxyAssessList(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/xyAssess',
        data: params
    })
}
export function xyPush(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/xyPush',
        data: params
    })
}
// 自动报价折扣获取
export function discountInfo(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/discountInfo',
        data: params
    })
}
// 自动报价折扣保存
export function discountSet(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/discountSet',
        data: params
    })
}
// 机型价格详情
export function phonePriceInfo(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/phonePriceInfo',
        data: params
    })
}
// 省份价格配置列表
export function provincePriceConfig(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/provincePriceConfig',
        data: params
    })
}
// 渠道下拉
export function channePull(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/channePull',
        data: params
    })
}
// 旧机品牌下拉
export function brandPull(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/brandPull',
        data: params
    })
}
// 串号查询-终端零售价查询
export function queryImei(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/queryImei',
        data: params
    })
}
// 串号查询-入库记录列表
export function modelList(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/modelList',
        data: params
    })
}
// 串号查询-查询结果
export function queryResult(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/queryResult',
        data: params
    })
}
export function queryImeiDown(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/queryImeiDown',
        data: params,
        responseType: 'blob'
    })
}
// 运单监控
export function orderLogistics(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/orderLogistics',
        data: params
    })
}
// 物流路由信息
export function orderLogisticsInfo(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/orderLogisticsInfo',
        data: params
    })
}
// 服务单列表
export function serviceList(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/serviceList',
        data: params
    })
}
// 运单监控导出
export function orderLogisticsDown(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/orderLogisticsDown',
        data: params,
        responseType: 'blob'
    })
}
// 年年焕新-品牌机型列表
export function brandModelList(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/brandModelList',
        data: params
    })
}
// 年年焕新-品牌机型入库
export function modelSave(params) {
    return request({
        method: 'POST',
        url: '/Xiaoyi/modelSave',
        data: params
    })
}
